import { toneBadge, type StatusTone } from "@/lib/statusTone";

/**
 * Palette badges by meaning, not by colour name: "active" and "paused" are
 * the same states the rest of the app shows, so they wear the same colours.
 * "brand" is the app's own accent, for an action rather than a state.
 */
export type PaletteBadge = StatusTone | "brand";

export function badgeClasses(variant: PaletteBadge): string {
  if (variant === "brand") {
    return "bg-violet-500/15 text-violet-300 border border-violet-500/30";
  }
  return `border ${toneBadge[variant]}`;
}

export function renderIcon(type: "navigation" | "worker" | "action", selected: boolean) {
  const iconTone = selected ? "text-violet-400" : "text-zinc-500";

  if (type === "navigation") {
    return (
      <svg viewBox="0 0 16 16" fill="none" className={`size-4 shrink-0 ${iconTone}`}>
        <path
          d="M2.5 8h11M9 3.5l4.5 4.5L9 12.5"
          stroke="currentColor"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (type === "worker") {
    return (
      <svg viewBox="0 0 16 16" fill="none" className={`size-4 shrink-0 ${iconTone}`}>
        <rect
          x="3"
          y="4.5"
          width="10"
          height="8.5"
          rx="1.5"
          stroke="currentColor"
          strokeWidth="1.3"
        />
        <circle cx="6" cy="8.5" r="0.75" fill="currentColor" />
        <circle cx="10" cy="8.5" r="0.75" fill="currentColor" />
        <path
          d="M8 2.5v2M5.5 2.5h5"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 16 16" fill="none" className={`size-4 shrink-0 ${iconTone}`}>
      <path
        d="M8.75 1.75 3.5 9h3.25l-.5 5.25L11.5 7H8.25l.5-5.25Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** The chevron on every "back to the command list" button. */
export function BackArrowIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" className="size-4">
      <path
        d="M10 3.5 5.5 8 10 12.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
